/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "snapchat.common";

/** Randomization unit ID */
export interface Ruid {
  /** Type of ID for request */
  type: Ruid_Type;
  /** String value of ID */
  stringValue: string;
  /**
   * When specifying a privacy-sensitive RUID (such as device_id), a logging ID should be used instead of the RUID for logging.
   * Each privacy-sensitive RUID type maps to a replacement logging ID type (for example: device_id -> client_id).
   * Note: this is suffixed with `_value` both to indicate it's a value and to avoid conflict with the LoggingId DTO.
   */
  loggingIdValue: string;
}

/** Randomization units supported for allocation */
export enum Ruid_Type {
  /** UNSET - Unknown type */
  UNSET = 0,
  /** USER - Snapchat user ID */
  USER = 1,
  /** DEVICE - Config device ID */
  DEVICE = 2,
  /** WEB_CLIENT - Web client ID */
  WEB_CLIENT = 3,
  /** AD_ACCOUNT - Ad account ID */
  AD_ACCOUNT = 4,
  /** USERNAME - Snapchat username (legacy only) */
  USERNAME = 5,
  /** AD_MODERATION_AD - Ad Id used by Ad Moderation backend. */
  AD_MODERATION_AD = 6,
  /** WEB_SNAPCHAT_USER - Snapchat user id used on web. */
  WEB_SNAPCHAT_USER = 7,
  /** INTERNAL - Internal test RUID, internal use only and no analysis. */
  INTERNAL = 8,
  /** AM_ORGANIZATION - Ads Manager organization ID */
  AM_ORGANIZATION = 9,
  /** AM_MEMBER - Ads Manager member ID */
  AM_MEMBER = 10,
  /** AM_SESSION - Ads Manager session ID */
  AM_SESSION = 11,
  /** AM_PROFILE - Ads Manager profile ID */
  AM_PROFILE = 12,
  /** AM_SNAPCHAT_USER - Snapchat user ID on Ads Manager */
  AM_SNAPCHAT_USER = 13,
  /** SNAPCHAT_ADVERTISING - Snapchat Advertising ID for Budget A/B */
  SNAPCHAT_ADVERTISING = 14,
  /** AM_CLIENT - Ads Manager client ID */
  AM_CLIENT = 15,
  /** MISCHIEF - Mischief id for group chat */
  MISCHIEF = 16,
  /** ARES_VISITOR - ARES VISITOR ID */
  ARES_VISITOR = 17,
  UNRECOGNIZED = -1,
}

function createBaseRuid(): Ruid {
  return { type: 0, stringValue: "", loggingIdValue: "" };
}

export const Ruid = {
  encode(message: Ruid, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.stringValue !== "") {
      writer.uint32(18).string(message.stringValue);
    }
    if (message.loggingIdValue !== "") {
      writer.uint32(26).string(message.loggingIdValue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Ruid {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRuid();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.type = reader.int32() as any;
          break;
        case 2:
          message.stringValue = reader.string();
          break;
        case 3:
          message.loggingIdValue = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromPartial<I extends Exact<DeepPartial<Ruid>, I>>(object: I): Ruid {
    const message = createBaseRuid();
    message.type = object.type ?? 0;
    message.stringValue = object.stringValue ?? "";
    message.loggingIdValue = object.loggingIdValue ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
